module.exports = __webpack_public_path__ + "img/icon-search.29e60cba.svg";